"use strict";
// Photogram Metadata
Object.defineProperty(exports, "__esModule", { value: true });
const operators_1 = require("rxjs/operators");
const core_1 = require("@angular/core");
const _4d_mapper_1 = require("4d-mapper");
const forms_1 = require("@angular/forms");
const file_manager_service_1 = require("../../../../service/file-manager.service");
const material_1 = require("@angular/material");
const app_service_1 = require("../../../../commons/app.service");
const router_1 = require("@angular/router");
const core_2 = require("@ngx-translate/core");
const map_service_1 = require("../../../../commons/map.service");
const http_1 = require("@angular/common/http");
const epsg_helper_service_1 = require("../../../../service/epsg-helper.service");
// import * as fs from 'fs';
const AppBaseComponent_1 = require("../../../../commons/AppBaseComponent");
const Constants_1 = require("../../../../commons/Constants");
const application_events_service_1 = require("../../../../xs/services/events/application-events.service");
const coord_helper_service_1 = require("../../../../service/coord-helper.service");
const Cesium = window.Cesium;
class MetadataDialogComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, r, sn, d, ar, t, trans, fb, cd, fileManager, dialogRef, snackBar, mapService, data, httpClient, applicationEvents, epsgHelper) {
        super(service, r, sn, d, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.r = r;
        this.ar = ar;
        this.t = t;
        this.trans = trans;
        this.fb = fb;
        this.cd = cd;
        this.fileManager = fileManager;
        this.dialogRef = dialogRef;
        this.snackBar = snackBar;
        this.mapService = mapService;
        this.data = data;
        this.httpClient = httpClient;
        this.epsgHelper = epsgHelper;
        // refactor
        this.debug = Constants_1.Constants.debug_off;
        this.useCoordsFrom = 'images';
        this.isGroundControlPoints = false;
        // old code
        this.isOver = false;
        this.csvRecords = [];
        this.name = new forms_1.FormControl('', [
            forms_1.Validators.required
        ]);
        this.latLongSwap = false;
        // Images metadata (table column headers)
        this.imageName = { value: 'MAP.PHOTOGRAM.IMAGE_NAME' };
        // select = 'Select';
        this.latitude = { value: 'MAP.PHOTOGRAM.LATITUDE' };
        this.longitude = { value: 'MAP.PHOTOGRAM.LONGITUDE' };
        this.height = { value: 'GENERIC.HEIGHT' };
        this.latitude_accuracy = { value: 'MAP.PHOTOGRAM.LATITUDE_ACCURACY' };
        this.longitude_accuracy = { value: 'MAP.PHOTOGRAM.LONGITUDE_ACCURACY' };
        this.height_accuracy = { value: 'MAP.PHOTOGRAM.HEIGHT_ACCURACY' };
        // headersRow        = [this.imageName, this.longitude, this.latitude, this.height, this.longitude_accuracy, this.latitude_accuracy, this.height_accuracy];
        this.headersRowColumns = [this.imageName, this.longitude, this.latitude, this.height, this.longitude_accuracy, this.latitude_accuracy, this.height_accuracy];
        this.selectedHeader = [this.imageName, this.longitude, this.latitude, this.height, this.longitude_accuracy, this.latitude_accuracy, this.height_accuracy];
        // refactor
        // new column headers
        this.columnHeaders = null;
        this.longIndex = 1;
        this.latIndex = 2;
        this.matSelect = [];
        this.matSelectSource = [];
        this.searchEPSGControll = new forms_1.FormControl();
        this.inValidData = false;
        this.file = null;
        this.fileName = null;
        this.folderAdded = true;
        this.loadingData = false;
        this.DEFAULT_LATITUDE_ACCURACY = 5;
        this.DEFAULT_LONGITUDE_ACCURACY = 5;
        this.DEFAULT_HEIGHT_ACCURACY = 5;
        this.importedFolderNames = '';
        this.totalImportedImages = 0;
        this.foldersToAdd = [];
        this.DATA_FROM_FOLDER = true;
        this.selectedGeoIdModelNone = 'None';
        this.selectedGeoIdModel = this.selectedGeoIdModelNone;
        this.csvRecordsCopy = [];
        this.heightInvalid = false;
        this.csvRecordsFromImageHeader = [];
        // refactor; better state and detection for imported CSV coordinates
        // CsvCoordsDifferentCRS:boolean = false;
        // CsvCoordsXYFlipped:boolean = false;
        // originalRowXYZ:any = null;
        // importedRowXYZ:any = null;
        this.originalImages = null;
        if (this.data.isReference) {
            this.DEFAULT_LATITUDE_ACCURACY = 0.02;
            this.DEFAULT_LONGITUDE_ACCURACY = 0.02;
            this.DEFAULT_HEIGHT_ACCURACY = 0.02;
        }
        this.originalImages = new Map();
    }
    init() {
        if (this.debug) {
            console.log('photogrammetry-meta :: init()');
        }
        // search for EPSG ; refactored, not used anymore
        /*
        this.searchEPSGControll.valueChanges.pipe(debounceTime(1000)).subscribe(s => {
          if(s['name']){
            this.onInputChanged(s['name']);
          }else{
            this.onInputChanged(s);
          }
        });
        */
        // this.myOptionSelected();
        // fuuuuuuuuuck, this code is bananas!
        this.isGroundControlPoints = this.data.isReference;
        if (this.data.currentJob) {
            this.loadingData = true;
            this.currentJob = this.data.currentJob;
            if (this.debug) {
                console.log('photogrammetry-meta :: ngOnInit() currentJob');
            }
            // refactor; flagging huge BUG / ERROR / MISGUIDED ideas
            // this is a specific account in the Beta / Prod database. This will always fail in any other environments!
            // Also, it's a specific Transform to a specific Account! Here be dragons / madness / insanity!
            this.fourD.V.searchByObject(_4d_mapper_1.Transform).equals('account', 297).queryObservable().subscribe(value => {
                if (value.items.length > 0) {
                    this.geoIdModelList = value.items;
                    if (this.currentJob['selectedGeoIdModel'] && this.currentJob['selectedGeoIdModel'] !== this.selectedGeoIdModelNone) {
                        this.selectedGeoIdModel = this.geoIdModelList.find(g => g.id === this.currentJob['selectedGeoIdModel']);
                    }
                    else
                        this.currentJob['selectedGeoIdModel'] = this.selectedGeoIdModelNone;
                }
            }, error1 => console.log(error1));
            this.currentScene = this.data.currentScene;
            this.csvRecordsFromImageHeader = [];
            this.getAllOrigionalJpegImagesFromFolder(false, true);
            // isReference really means isControlPoints
            if (this.currentJob['REFERENCE_FILE']) {
                this.fileName = this.currentJob['REFERENCE_FILE'];
            }
            if (this.currentJob['COORD_FILE'] && this.currentJob['COORD_FILE']) {
                this.fileName = this.currentJob['COORD_FILE'];
                this.useCoordsFrom = 'file';
            }
            // refactor
            let check = this.currentJob[this.mapService.JOB_EPSG_CODE];
            if (this.isGroundControlPoints) {
                check = this.currentJob[this.mapService.JOB_REF_EPSG_CODE];
            }
            if (check) {
                let value = this.epsgHelper.getCodeObjectObservable(check).subscribe(item => {
                    if (this.debug) {
                        console.log('photogrammetry-meta :: ngOnInit() epsg (' + check + ') got back', check, item);
                    }
                    this.searchEPSGControll.setValue(item.name);
                    // this.onInputChanged(item.name);
                    this.selectedOption = item;
                    this.setLatLongHeightByCSRType(item);
                });
            }
            else {
                this.setDefaultEPSGCode();
            }
            /*
                  if (this.isGroundControlPoints && this.currentJob[this.mapService.JOB_REF_EPSG_CODE]) {
                      this.fourD.V.searchByObject(EPSGCodes).equals('uid', this.currentJob[this.mapService.JOB_REF_EPSG_CODE]).queryObservable().subscribe(value => {
                        this.searchEPSGControll.setValue(value.items[0].name);
                        this.onInputChanged(value.items[0].name);
                        this.selectedOption = value.items[0];
                        this.setLatLongHeightByCSRType(this.selectedOption);
                      });
                  }else{
                    if (this.currentJob[this.mapService.JOB_EPSG_CODE]) {
                      if ( this.debug ) { console.log ( 'photogrammetry-meta :: ngOnInit() has epsg code', this.currentJob[this.mapService.JOB_EPSG_CODE] ); }
            
                      this.fourD.V.searchByObject(EPSGCodes).equals('uid', this.currentJob[this.mapService.JOB_EPSG_CODE]).queryObservable().subscribe(value => {
                        this.searchEPSGControll.setValue(value.items[0].name);
                        this.onInputChanged(value.items[0].name);
                        this.selectedOption = value.items[0];
                        this.setLatLongHeightByCSRType(this.selectedOption);
                      });
                    } else {
                      this.setDefaultEPSGCode();
                    }
                  }
                  */
            if (this.currentJob[this.mapService.DATA_FROM_FOLDER] !== undefined) {
                this.DATA_FROM_FOLDER = this.currentJob[this.mapService.DATA_FROM_FOLDER];
            }
            this.currentJob.inputDatasets.queryObservable().subscribe(value => {
                if (this.debug) {
                    console.log('photogrammetry-meta :: ngOnInit() has inputDatasets', value);
                }
                if (value.items && value.items.length > 0) {
                    this.folderAdded = true;
                    let dataset;
                    if (this.data.isReference) {
                        value.items.forEach(value1 => {
                            if (value1.name.indexOf(this.mapService.FOURDDMAPPER_REFERENCE) !== -1) {
                                dataset = value1;
                                if (this.debug) {
                                    console.log('photogrammetry-meta :: ngOnInit() has inputDatasets REFERENCE DATA', value1);
                                }
                            }
                        });
                    }
                    else {
                        value.items.forEach(value1 => {
                            if (value1.name.indexOf(this.mapService.FOURDDMAPPER_REFERENCE) === -1) {
                                dataset = value1;
                                if (this.debug) {
                                    console.log('photogrammetry-meta :: ngOnInit() has inputDatasets META DATA', value1);
                                }
                            }
                        });
                    }
                    if (dataset) {
                        this.httpClient.get(dataset.file('data'), { responseType: 'text' })
                            .pipe(operators_1.tap(data => data, error => console.log(error)))
                            .subscribe(s => {
                            /* var st = JSON.stringify(s);
                             var sst = JSON.parse(st);*/
                            // console.log(sst);
                            if (this.debug) {
                                console.log('photogrammetry-meta :: init sub fetching file', dataset);
                            }
                            if (this.data.isReference) {
                                if (this.currentJob['referenceIndex']) {
                                    this.headersRowColumns[this.currentJob['referenceIndex']['imageIndex']] = this.imageName;
                                    this.headersRowColumns[this.currentJob['referenceIndex']['heightIndex']] = this.height;
                                    this.headersRowColumns[this.currentJob['referenceIndex']['latitudeIndex']] = this.latitude;
                                    this.headersRowColumns[this.currentJob['referenceIndex']['longitudeIndex']] = this.longitude;
                                    this.headersRowColumns[this.currentJob['referenceIndex']['longitudeAccuracyIndex']] = this.longitude_accuracy;
                                    this.headersRowColumns[this.currentJob['referenceIndex']['latitudeAccuracyIndex']] = this.latitude_accuracy;
                                    this.headersRowColumns[this.currentJob['referenceIndex']['heightAccuracyIndex']] = this.height_accuracy;
                                    this.selectedHeader[this.currentJob['referenceIndex']['imageIndex']] = this.imageName;
                                    this.selectedHeader[this.currentJob['referenceIndex']['heightIndex']] = this.height;
                                    this.selectedHeader[this.currentJob['referenceIndex']['latitudeIndex']] = this.latitude;
                                    this.selectedHeader[this.currentJob['referenceIndex']['longitudeIndex']] = this.longitude;
                                    this.selectedHeader[this.currentJob['referenceIndex']['longitudeAccuracyIndex']] = this.longitude_accuracy;
                                    this.selectedHeader[this.currentJob['referenceIndex']['latitudeAccuracyIndex']] = this.latitude_accuracy;
                                    this.selectedHeader[this.currentJob['referenceIndex']['heightAccuracyIndex']] = this.height_accuracy;
                                    this.latLongSwapping();
                                }
                            }
                            else {
                                if (this.currentJob['metaIndex']) {
                                    this.headersRowColumns[this.currentJob['metaIndex']['imageIndex']] = this.imageName;
                                    this.headersRowColumns[this.currentJob['metaIndex']['heightIndex']] = this.height;
                                    this.headersRowColumns[this.currentJob['metaIndex']['latitudeIndex']] = this.latitude;
                                    this.headersRowColumns[this.currentJob['metaIndex']['longitudeIndex']] = this.longitude;
                                    this.headersRowColumns[this.currentJob['metaIndex']['longitudeAccuracyIndex']] = this.longitude_accuracy;
                                    this.headersRowColumns[this.currentJob['metaIndex']['latitudeAccuracyIndex']] = this.latitude_accuracy;
                                    this.headersRowColumns[this.currentJob['metaIndex']['heightAccuracyIndex']] = this.height_accuracy;
                                    this.selectedHeader[this.currentJob['metaIndex']['imageIndex']] = this.imageName;
                                    this.selectedHeader[this.currentJob['metaIndex']['heightIndex']] = this.height;
                                    this.selectedHeader[this.currentJob['metaIndex']['latitudeIndex']] = this.latitude;
                                    this.selectedHeader[this.currentJob['metaIndex']['longitudeIndex']] = this.longitude;
                                    this.selectedHeader[this.currentJob['metaIndex']['longitudeAccuracyIndex']] = this.longitude_accuracy;
                                    this.selectedHeader[this.currentJob['metaIndex']['latitudeAccuracyIndex']] = this.latitude_accuracy;
                                    this.selectedHeader[this.currentJob['metaIndex']['heightAccuracyIndex']] = this.height_accuracy;
                                    this.latLongSwapping();
                                }
                            }
                            // this.headersRow = [this.imageName, this.latitude, this.longitude, this.height];
                            s.split('\n').forEach(value1 => {
                                let t = value1.split(',');
                                // let record = [t[0], t[1], t[2], t[3]];
                                if (t && t.length > 1) {
                                    let record = [];
                                    t.forEach(value => {
                                        record.push(value.trim());
                                    });
                                    this.csvRecords.push(record);
                                }
                            });
                            this.makeCSVRecordscopy();
                            this.loadingData = false;
                            if (!this.data.isReference) {
                                this.injectCSVCoordsIntoImages();
                                // this.readDataFromFolder(false);
                                // this.getAllJpegImagesFromFolder(false);
                            }
                        }, error1 => {
                            this.loadingData = false;
                        });
                    }
                    else {
                        this.loadingData = false;
                        if (!this.data.isReference) {
                            // this.readDataFromFolder(true);
                            this.getAllJpegImagesFromFolder(true);
                        }
                    }
                    /*this.fourD.V.api('/api/Dataset/' + value.items[0].id + '/data', ).subscribe(value1 => {
                      console.log(value1);
                    })*/
                }
                else if (!this.data.isReference) {
                    // this.readDataFromFolder(true);
                    this.getAllJpegImagesFromFolder(true);
                }
                else {
                    if (this.data.isReference) {
                        this.folderAdded = true;
                    }
                    this.loadingData = false;
                }
            }, error1 => {
                this.loadingData = false;
            });
        }
        else {
            this.setDefaultEPSGCode();
        }
        /*this.dialogRef.backdropClick().subscribe(value => {
          this.saveAndApply();
        });*/
    }
    injectCSVCoordsIntoImages() {
        console.log('%c photogram-metadata :: injectCSVCoordsIntoImages()', Constants_1.Constants._orange, this.originalImages, this.csvRecords);
    }
    selectEPSGCode(incode = null) {
        this.openEPSGDialogWith('MAP.PHOTOGRAM.SELECT_EPSG_CODE_IMPORTED_FILE').subscribe(code => {
            if (this.debug) {
                console.log('photogrammetry-meta :: selectEPSGCode()', code);
            }
            if (code) {
                // added test for and new way of fetching code description
                let desc = code.desc ? (' ' + code.desc).trim() : '';
                if (desc !== '') {
                    var sourceProjection = code.desc;
                    if (!sourceProjection) {
                        this.openSnackBarError('MAP.PHOTOGRAM.EPSG_DESCRIPTION');
                        return;
                    }
                    code['isProjected'] = false;
                    if (code['desc'].indexOf('PROJCS[') !== -1) {
                        code['isProjected'] = true;
                    }
                    this.selectedOption = code;
                    this.setLatLongHeightByCSRType(this.selectedOption);
                }
                else {
                    if (this.debug) {
                        console.log('photogrammetry-meta :: selectEPSGCode(), default description missing, trying API');
                    }
                    // assumes 'value' is always the actual EPSG code
                    let q = this.epsgHelper.getCodeObjectObservable(code.uid).subscribe(res => {
                        // code['old_desc'] = code.desc;
                        // code.desc = res.desc;
                        if (this.debug) {
                            console.log('photogrammetry-meta :: selectEPSGCode(), API', res);
                        }
                        var sourceProjection = res.desc;
                        if (!sourceProjection) {
                            this.openSnackBarError('MAP.PHOTOGRAM.EPSG_DESCRIPTION');
                            return;
                        }
                        this.selectedOption = res;
                        // this.resetCSVRecords();
                        // this.updateCSVRecordByEPSGCode();
                        this.setLatLongHeightByCSRType(this.selectedOption);
                    });
                }
            }
        });
    }
    setDefaultEPSGCode() {
        if (this.debug) {
            console.log('photogrammetry-meta :: setDefaultEPSGCode()');
        }
        // refactored; searching for UIDs instead of names
        this.fourD.V.searchByObject(_4d_mapper_1.EPSGCodes).equals('uid', '4326').queryObservable().subscribe(value => {
            this.searchEPSGControll.setValue(value.items[0].name);
            // this.onInputChanged(value.items[0].name);
            this.selectedOption = value.items[0];
            if (this.debug) {
                console.log('photogrammetry-meta :: setDefaultEPSGCode()', this.selectedOption);
            }
            this.setLatLongHeightByCSRType(this.selectedOption);
        });
        // this.searchEPSGControll.setValue('EPSG::4326 GCS_WGS_1984');
        // this.onInputChanged('EPSG::4326 GCS_WGS_1984');
    }
    /*private readDataFromFolder(appendCSVRecords: boolean) {
      this.currentJob.inputFolders.queryParams = {limit: 25};
      this.currentJob.inputFolders.queryObservable().subscribe(inputFolders => {
          if (inputFolders && inputFolders.items && inputFolders.items.length > 0) {
            this.folderAdded = true;
            this.totalImportedImages = 0;
            inputFolders.items.forEach(value1 => {
              if(this.foldersToAdd.findIndex(value => value.id === value1.id) === -1){
                this.foldersToAdd.push(value1);
              }
              this.importedFolderNames += value1.name + ',';
              this.getAllJpegImagesFromFolder(value1.id, appendCSVRecords);
            });
            this.importedFolderNames = this.importedFolderNames.substr(0, this.importedFolderNames.lastIndexOf(','));
  
          } else if (this.foldersToAdd.length > 0) {
            this.folderAdded = true;
            this.totalImportedImages = 0;
            this.foldersToAdd.forEach(value1 => {
              this.importedFolderNames += value1.name + ',';
              this.getAllJpegImagesFromFolder(value1.id, appendCSVRecords);
            });
            this.importedFolderNames = this.importedFolderNames.substr(0, this.importedFolderNames.lastIndexOf(','));
          } else {
  
            this.loadingData = false;
          }
        },
        error1 => {
          this.loadingData = false;
        })
    }*/
    onInputChanged(searchStr) {
        if (this.debug) {
            console.log('photogrammetry-meta :: onInputChanged()', searchStr);
        }
        this.options = [];
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        let search = this.fourD.V.searchByObject(_4d_mapper_1.EPSGCodes).contains('name', searchStr);
        search.queryObservable().subscribe((result) => {
            result.items.forEach(value => {
                this.options.push(value);
            });
            if (this.options.length === 1) {
                this.selectedOption = this.options[0];
                this.setLatLongHeightByCSRType(this.selectedOption);
            }
        });
    }
    displayFn(item) {
        let x = this.matAutocomplete.options.filter(x => x.value === item).map(x => x.viewValue)[0] ? this.matAutocomplete.options.filter(x => x.value === item).map(x => x.viewValue)[0] : item;
        if (item instanceof _4d_mapper_1.EPSGCodes) {
            this.selectedOption = item;
            this.setLatLongHeightByCSRType(item);
        }
        return x;
        /*
    
        console.log(item);
        let x = this.matAutocomplete.options.filter(x => {
          return x.value === item
        }).map(x => {
          console.log(x.viewValue,x);
          x.viewValue
        })[0] ? this.matAutocomplete.options.filter(x => {
          return x.value === item
        }).map(x => {
          console.log(x.viewValue,x);
          x.viewValue
        })[0] : item;
        console.log(x);
        return x;
         */
    }
    stateLabel(type, isSwapped = false, isProjected = false) {
        let label = isSwapped ? coord_helper_service_1.LatLong.latitudeLabel : coord_helper_service_1.LatLong.longitudeLabel;
        if (type == coord_helper_service_1.LatLong.latitude) {
            label = isSwapped ? coord_helper_service_1.LatLong.longitudeLabel : coord_helper_service_1.LatLong.latitudeLabel;
        }
        if (isProjected) {
            label = isSwapped ? coord_helper_service_1.LatLong.northingLabel : coord_helper_service_1.LatLong.eastingLabel;
            if (type == coord_helper_service_1.LatLong.latitude) {
                label = isSwapped ? coord_helper_service_1.LatLong.eastingLabel : coord_helper_service_1.LatLong.northingLabel;
            }
        }
        return label;
    }
    setLatLongHeightByCSRType(item) {
        this.checkImportedCoords();
        let isSwapped = this.currentJob['latLongSwap'];
        let isProjected = item.isProjected;
        this.columnHeaders = [
            'Image name',
            this.stateLabel(coord_helper_service_1.LatLong.longitude, isSwapped, isProjected),
            this.stateLabel(coord_helper_service_1.LatLong.latitude, isSwapped, isProjected),
            'Height',
            this.stateLabel(coord_helper_service_1.LatLong.latitude, false, isProjected) + ' accuracy',
            this.stateLabel(coord_helper_service_1.LatLong.longitude, false, isProjected) + ' accuracy',
            'Height accuracy'
        ];
        if (this.debug) {
            console.log('photogrammetry-meta :: setLatLongHeightByCSRType()', isSwapped, isProjected, this.columnHeaders, this.currentJob['CsvCoordsXYFlipped']);
        }
        // if ( item.isProjected ) {
        // this.columnHeaders = [ 'Image name', this.stateLabel( CoordLabels.latitude ), 'Longitude', 'Height', 'Latitude accuracy', 'Longitude accuracy', 'Height accurancy' ];
        // this.latitude.value = 'Northing';
        // this.longitude.value = 'Easting';
        /* if ( this.currentJob['CsvCoordsXYFlipped'] ) {
          this.latitude.value = 'Easting';
          this.longitude.value = 'Northing';
        } */
        // this.height.value = 'Height';
        // this.latitude_accuracy.value = 'Northing Accuracy';
        // this.longitude_accuracy.value = 'Easting Accuracy';
        // this.height_accuracy.value = 'Height Accuracy';
        // } else {
        // this.columnHeaders = [ 'Image name', 'Northing', 'Easting', 'Height', 'Northing accuracy', 'Easting accuracy', 'Height accurancy' ];
        // this.latitude.value = 'Latitude';
        // this.longitude.value = 'Longitude';
        /* if ( this.currentJob['CsvCoordsXYFlipped'] ) {
          this.latitude.value = 'Longitude';
          this.longitude.value = 'Latitude';
        } */
        // this.height.value = 'Height';
        // this.latitude_accuracy.value = 'Latitude Accuracy';
        // this.longitude_accuracy.value = 'Longitude Accuracy';
        // this.height_accuracy.value = 'Height Accuracy';
        // }
        // temporary turn conversion off       this.updateCSVRecordByEPSGCode();
    }
    saveAndApply() {
        if (this.debug) {
            console.log('photogrammetry-meta :: saveAndApply()');
        }
        if (this.csvRecords && this.csvRecords.length > 0) {
            if (this.heightInvalid)
                this.resetCSVRecords();
            if (this.selectedGeoIdModel && this.selectedGeoIdModel !== this.selectedGeoIdModelNone) {
                this.currentJob['selectedGeoIdModel'] = this.selectedGeoIdModel.id;
            }
            else if (this.selectedGeoIdModel === this.selectedGeoIdModelNone) {
                this.currentJob['selectedGeoIdModel'] = this.selectedGeoIdModelNone;
            }
            var geographicProjection = 'EPSG:4326'; // 'GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]]';
            var sourceProjection = this.selectedOption.desc;
            if (!sourceProjection) {
                this.openSnackBarError('MAP.PHOTOGRAM.EPSG_DESCRIPTION');
                return;
            }
            //x = long , y= lat
            // 'Latitude', 'Longitude'
            // are we to swap them around?
            /* if ( this.currentJob['latLongSwap'] ) {
              let z = longitudeIndex;
              longitudeIndex = latitudeIndex;
              latitudeIndex = z;
            } */
            let longLatArray = [];
            // are we swapping lat / long?
            let swapLatLong = this.currentJob['latLongSwap'];
            let longitudeIndex = swapLatLong ? coord_helper_service_1.LatLong.latitude : coord_helper_service_1.LatLong.longitude;
            let latitudeIndex = swapLatLong ? coord_helper_service_1.LatLong.longitude : coord_helper_service_1.LatLong.latitude;
            let heightIndex = this.selectedHeader.findIndex(value => value === this.height);
            let longitudeArray = [];
            let latitudeArray = [];
            if (this.debug) {
                console.log('%c photogrammetry-meta :: saveAndApply() CONV', Constants_1.Constants._blue, longitudeIndex, latitudeIndex, swapLatLong, sourceProjection, geographicProjection);
            }
            let debug = 0;
            // canonical coordinates with both EPSG:4326 / WGS_1984 and originals if different
            let canonical = {};
            // convert all CSV records into an array of coords
            this.csvRecords.forEach(value => {
                let r = [+value[longitudeIndex], +value[latitudeIndex]];
                let conv = this.epsgHelper.convert(sourceProjection, geographicProjection, r);
                canonical[value[0] + ''.trim()] = { latitude: conv[1], longitude: conv[0], height: value[heightIndex], longLatOriginal: r, columnsSwapped: swapLatLong, convertedFrom: sourceProjection };
                longLatArray.push(conv);
                if (debug++ < 5) {
                    if (this.debug) {
                        console.log('%c photogrammetry-meta :: saveAndApply() convert ' + debug, Constants_1.Constants._blue, value, r, conv);
                    }
                }
            });
            var cameraPositions = [];
            let i = 0;
            debug = 0;
            longLatArray.forEach(value => {
                cameraPositions.push(new Cesium.Cartesian3.fromDegrees(value[0], value[1], this.csvRecords[i++][heightIndex]));
                if (debug++ < 5) {
                    if (this.debug) {
                        console.log('%c photogrammetry-meta :: saveAndApply() cartesian ' + debug, Constants_1.Constants._blue, value);
                    }
                }
                if (value[0] != 0 && value[1] != 0) {
                    longitudeArray.push(value[0]);
                    latitudeArray.push(value[1]);
                }
            });
            var west = Math.min(...longitudeArray);
            var south = Math.min(...latitudeArray);
            var east = Math.max(...longitudeArray);
            var north = Math.max(...latitudeArray);
            var rectangle = Cesium.Rectangle.fromDegrees(west, south, east, north);
            if (this.debug) {
                console.log('%c photogrammetry-meta :: saveAndApply() rectangle', Constants_1.Constants._blue, rectangle, cameraPositions, this.foldersToAdd);
            }
            this.foldersToAdd.forEach(value => {
                this.mapService.transformsFromFolder.next(value);
            });
            this.currentJob[this.mapService.DATA_FROM_FOLDER] = this.DATA_FROM_FOLDER;
            if (this.data.isReference) {
                this.currentJob[this.mapService.JOB_REF_EPSG_CODE] = this.selectedOption.uid;
                this.currentJob[this.mapService.JOB_REF_EPSG_CODE_DESC] = this.selectedOption.desc;
            }
            else {
                this.currentJob[this.mapService.JOB_EPSG_CODE] = this.selectedOption.uid;
                this.currentJob[this.mapService.JOB_EPSG_CODE_DESC] = this.selectedOption.desc;
            }
            this.currentJob.saveObservable().subscribe();
            if (this.debug) {
                console.log('photogrammetry-meta :: saveAndApply() saving job');
            }
            this.dialogRef.close({
                rectangle: rectangle,
                cameraPositions: cameraPositions,
                csvRecords: this.csvRecords,
                canonical: canonical,
                index: {
                    longitudeIndex: longitudeIndex,
                    latitudeIndex: latitudeIndex,
                    heightIndex: heightIndex,
                    imageIndex: this.selectedHeader.findIndex(value => value === this.imageName),
                    longitudeAccuracyIndex: this.selectedHeader.findIndex(value => value === this.longitude_accuracy),
                    latitudeAccuracyIndex: this.selectedHeader.findIndex(value => value === this.latitude_accuracy),
                    heightAccuracyIndex: this.selectedHeader.findIndex(value => value === this.height_accuracy)
                },
                file: this.file
            });
        }
        else {
            this.dialogRef.close();
        }
    }
    dropFiles(e) {
        if (!this.folderAdded || this.loadingData)
            return;
        if (e.stopPropagation)
            e.stopPropagation();
        e.preventDefault();
        var filez = e.dataTransfer.files;
        console.log(filez);
        if (filez[0].name.endsWith('.csv') || filez[0].name.endsWith('.txt')) {
            this.isOver = false;
            this.readFile(filez[0]);
        }
        else {
            this.snackBar.open('MAP.PHOTOGRAM.FILE_TYPE', 'GENERIC.ERROR', { duration: Constants_1.Constants.SNACKBAR_DURATION });
        }
    }
    uploadFiles(e) {
        if (this.debug) {
            console.log('photogrammetry-meta :: uploadFiles()', e);
        }
        var filez = e.srcElement.files;
        var l = filez.length;
        this.readFile(filez[0]);
        this.isOver = false;
    }
    readFile(filez) {
        if (filez) {
            this.file = filez;
            if (this.file.name) {
                this.fileName = this.file.name;
            }
            var reader = new FileReader();
            reader.readAsText(filez);
            reader.onload = (data) => {
                let csvData = reader.result;
                let csvRecordsArray = csvData.split(/\r|\r\n|\n/);
                var headerLength = -1;
                if (file_manager_service_1.FileManagementService.isHeaderPresentFlag) {
                    headerLength = this.fileManager.getHeaderArray(csvRecordsArray, file_manager_service_1.FileManagementService.tokenDelimeter).length;
                }
                if (headerLength < 4) {
                    this.openSnackBarError('MAP.PHOTOGRAM.COLUMN_MINIMUM');
                    this.inValidData = true;
                    return;
                }
                this.inValidData = false;
                this.csvRecords = this.fileManager.getDataRecordsArrayFromCSVFile(csvRecordsArray, headerLength, file_manager_service_1.FileManagementService.validateHeaderAndRecordLengthFlag, file_manager_service_1.FileManagementService.tokenDelimeter, this.DEFAULT_LATITUDE_ACCURACY, this.DEFAULT_LONGITUDE_ACCURACY, this.DEFAULT_HEIGHT_ACCURACY);
                this.validateCSVdata();
                this.makeCSVRecordscopy();
                if (this.csvRecords[0] && !this.currentJob['importedRowXYZ']) {
                    this.currentJob['importedRowXYZ'] = this.csvRecords[0];
                    if (this.debug) {
                        console.log('photogrammetry-meta :: readFile(' + filez + ') importedRowXYZ SET', this.csvRecords[0]);
                    }
                }
                this.checkImportedCoords();
                if (this.csvRecords == null) {
                    //If control reached here it means csv file contains error, reset file.
                    this.fileReset();
                }
                this.DATA_FROM_FOLDER = false;
            };
            reader.onerror = () => {
                this.snackBar.open('GENERIC.READ_ERROR', 'GENERIC.ERROR', { duration: Constants_1.Constants.SNACKBAR_DURATION });
            };
        }
        ;
        /*const [file] = filez;
        reader.readAsText(file);
    
        reader.onload = () => {
          console.log(reader.result);
          // need to run CD since file load runs outside of zone
          this.cd.markForCheck();
        };*/
    }
    applyAccuracy(latAccuracy, longAccuracy, heightAccuracy) {
        if (this.debug) {
            console.log('photogrammetry-meta :: applyAccuracy()');
        }
        this.csvRecords.forEach(record => {
            if (latAccuracy) {
                record[this.selectedHeader.findIndex(value => value === this.latitude_accuracy)] = latAccuracy;
            }
            if (longAccuracy) {
                record[this.selectedHeader.findIndex(value => value === this.longitude_accuracy)] = longAccuracy;
            }
            if (heightAccuracy) {
                record[this.selectedHeader.findIndex(value => value === this.height_accuracy)] = heightAccuracy;
            }
        });
        this.csvRecordsFromImageHeader.forEach(record => {
            if (latAccuracy) {
                record[this.selectedHeader.findIndex(value => value === this.latitude_accuracy)] = latAccuracy;
            }
            if (longAccuracy) {
                record[this.selectedHeader.findIndex(value => value === this.longitude_accuracy)] = longAccuracy;
            }
            if (heightAccuracy) {
                record[this.selectedHeader.findIndex(value => value === this.height_accuracy)] = heightAccuracy;
            }
        });
        this.makeCSVRecordscopy();
    }
    fileReset() {
        if (this.debug) {
            console.log('photogrammetry-meta :: fileReset()');
        }
        this.fileInput.nativeElement.value = '';
        this.csvRecords = [];
        this.csvRecordsCopy = [];
        if (this.isGroundControlPoints) {
            this.currentJob['REFERENCE_FILE'] = null;
            this.currentJob['importedRowXYZ'] = null;
        }
        else {
            this.currentJob['COORD_FILE'] = null;
            this.currentJob['originalRowXYZ'] = null;
        }
    }
    dragOver(e) {
        e.preventDefault();
        this.isOver = true;
        return false;
    }
    dragLeave(e) {
        e.preventDefault();
        this.isOver = false;
        return false;
    }
    /*
    headerSwitch(event: MatSelectChange, j) {
      console.log(event, j);
      this.selectedHeader[j] = event.value;
      // value.value === event.value &&
      *if(this.matSelectSource.find(value => value.value === event.value && value.id !== event.source.id)){
        console.log(this.matSelectSource.find(value => value.value === event.value));
        /!*(<MatSelect>this.matSelectSource[this.matSelectSource.findIndex(value => value.id === event.source.id)]).writeValue(this.headersRowColumns[0]);*!/
        (this.matSelectSource.find(value => value.value === event.value)).setValue(this.headersRowColumns[0]);
      }else{
        if(!this.matSelectSource.find(value => value.id === event.source.id)){
          let id = event.source.id;
          let source = event.source;
          this.matSelectSource.push(source);
        }
        this.matSelect.push(event.source.id);
      }*
    }
  */
    /*addFolder() {
      this.openDialogWithMode('folder', 'PROJECT.DIALOG.ADD_FOLDER_TITLE', 'PROJECT.DIALOG.ADD_FOLDER_TEXT', '', '', '', {
        status: '',
        message: ''
      }, '30%')
        .subscribe(dest => {
            if (!dest) return;
            this.currentJob.inputFolders.equals('id', dest).queryObservable().subscribe(value => {
              if (value.items.length > 0) {
                this.openSnackBarError('MAP.PHOTOGRAM.FOLDER_EXIST')
              } else {
                this.folderAdded = true;
                this.loadingData = true;
                this.DATA_FROM_FOLDER = true;
                this.getAllJpegImagesFromFolder(dest.id, true, dest);
                // this.mapService.transformsFromFolder.next(dest);
              }
            });
          },
          e => this.openSnackBarError(e.message, null)
        )
  
    }*/
    getAllJpegImagesFromFolder(appendCSVRecords, folderId, dest) {
        if (this.debug) {
            console.log('%c photogrammetry-meta :: getAllJpegImagesFromFolder( appendCSVRecords="' + appendCSVRecords + '", folderId="' + folderId + '" , dest="' + dest + '" )', Constants_1.Constants._purple);
        }
        this.currentScene.photos.
            limit(10000).queryObservable().subscribe(value => {
            this.loadingData = false;
            if (value.items && value.items.length > 0) {
                // this.totalImportedImages += value.items.length;
                /* if (dest) {
                   if (this.importedFolderNames.length > 0) {
                     this.importedFolderNames += ',' + dest.name;
                   } else {
                     this.importedFolderNames = dest.name;
                   }
                   this.foldersToAdd.push(dest);
                   this.DATA_FROM_FOLDER = true;
                 }*/
                // this.headersRow = [this.imageName, this.latitude, this.longitude, this.height, this.latitude_accuracy, this.longitude_accuracy, this.height_accuracy];
                if (appendCSVRecords) {
                    if (this.debug) {
                        console.log('5c photogrammetry-meta :: getAllJpegImagesFromFolder( appendCSVRecords="' + appendCSVRecords + '", folderId="' + folderId + '" , dest="' + dest + '" )', Constants_1.Constants._red, this.csvRecords);
                    }
                    value.items.forEach(value1 => {
                        if (value1.llng && value1.llat) {
                            let record = [value1.name.replace('THUMB', '').replace('JPG_DZI', '').replace('DZI', '').trim(), value1.llng, value1.llat, value1.uheight, this.DEFAULT_LATITUDE_ACCURACY, this.DEFAULT_LONGITUDE_ACCURACY, this.DEFAULT_HEIGHT_ACCURACY];
                            this.csvRecords.push(record);
                        }
                    });
                    this.makeCSVRecordscopy();
                }
                // this.mapService.transformsFromFolder.next(value.items);
            }
            else {
                this.openSnackBarError('MAP.PHOTOGRAM.NO_JPEG');
            }
        }, error1 => {
            this.loadingData = false;
        });
    }
    getAllOrigionalJpegImagesFromFolder(appendCSVRecords, makeCopy) {
        if (this.debug) {
            console.log('photogrammetry-meta :: getAllOrigionalJpegImagesFromFolder( appendCSVRecords="' + appendCSVRecords + '", makeCopy="' + makeCopy + '" )');
        }
        this.currentScene.photos.limit(10000).queryObservable().subscribe(value => {
            if (value.items && value.items.length > 0) {
                // if (appendCSVRecords || makeCopy) {
                value.items.forEach(value1 => {
                    if (value1['exif_loc'] && value1['exif_loc']['lat']) {
                        let record = [value1.input.name ? value1.input.name : value1.name.replace('THUMB', '').replace('DZI', '').trim(), value1['exif_loc']['lng'], value1['exif_loc']['lat'], value1['exif_loc']['height'], this.DEFAULT_LATITUDE_ACCURACY, this.DEFAULT_LONGITUDE_ACCURACY, this.DEFAULT_HEIGHT_ACCURACY];
                        if (!this.currentJob['originalRowXYZ']) {
                            this.currentJob['originalRowXYZ'] = record;
                        }
                        this.originalImages.set(record[0], record);
                        if (appendCSVRecords)
                            this.csvRecords.push(record);
                        if (makeCopy)
                            this.csvRecordsFromImageHeader.push(record);
                    }
                });
                if (appendCSVRecords) {
                    this.makeCSVRecordscopy();
                }
                // }
            }
            else {
                this.openSnackBarError('MAP.PHOTOGRAM.NO_JPEG');
            }
            if (appendCSVRecords) {
                this.loadingData = false;
            }
        }, error1 => {
            this.loadingData = false;
        });
    }
    ngOnChanges(changes) {
    }
    resetDataFromFolder() {
        if (this.debug) {
            console.log('photogrammetry-meta :: resetDataFromFolder()');
        }
        this.csvRecords = [];
        this.csvRecordsCopy = [];
        this.loadingData = true;
        this.importedFolderNames = '';
        this.DATA_FROM_FOLDER = true;
        this.fileName = null;
        this.selectedGeoIdModel = this.selectedGeoIdModelNone;
        this.currentJob['selectedGeoIdModel'] = this.selectedGeoIdModelNone;
        this.currentJob['CsvCoordsDifferentCRS'] = false;
        this.currentJob['CsvCoordsXYFlipped'] = false;
        this.currentJob['originalRowXYZ'] = null;
        this.currentJob['importedRowXYZ'] = null;
        // this.readDataFromFolder(true);
        // this.getAllJpegImagesFromFolder(true);
        this.getAllOrigionalJpegImagesFromFolder(true);
        this.setDefaultEPSGCode();
        this.latAccuracy.nativeElement.value = this.DEFAULT_LATITUDE_ACCURACY + '';
        this.longAccuracy.nativeElement.value = this.DEFAULT_LONGITUDE_ACCURACY + '';
        this.heightAccuracy.nativeElement.value = this.DEFAULT_HEIGHT_ACCURACY + '';
    }
    myOptionSelected() {
        // this.myCard.focus();
    }
    changeHeightByGeoIdModel() {
        if (this.debug) {
            console.log('photogrammetry-meta :: changeHeightByGeoidModel()');
        }
        if (this.selectedGeoIdModel && this.selectedGeoIdModel !== this.selectedGeoIdModelNone) {
            this.loadingData = true;
            // this.csvRecords = Object.assign([], this.csvRecordsCopy);
            this.mapService.helper.addPlottable(this.selectedGeoIdModel).subscribe(_ => {
                var gridPositionsCartographic = [];
                this.resetCSVRecords();
                this.csvRecords.forEach(v => {
                    var positionCartographic = new Cesium.Cartographic((+v[1]) * Math.PI / 180, (+v[2]) * Math.PI / 180);
                    gridPositionsCartographic.push(positionCartographic);
                });
                var samplePromise = Cesium.sampleTerrainMostDetailed(this.mapService.viewer.terrainProvider, gridPositionsCartographic);
                samplePromise.then(_ => {
                    let i = 0;
                    gridPositionsCartographic.forEach(v => {
                        this.csvRecords[i][3] = ((+this.csvRecords[i][3]) - v.height).toFixed(3);
                        if (isNaN(this.csvRecords[i][3]))
                            this.heightInvalid = true;
                        i++;
                    });
                    this.loadingData = false;
                    this.mapService.helper.removePlottable(this.selectedGeoIdModel);
                });
            }, error1 => {
                this.loadingData = false;
                this.openSnackBarError('GENERIC.ERROR ' + error1.error.message);
                this.mapService.helper.removePlottable(this.selectedGeoIdModel);
            });
        }
        else {
            this.resetCSVRecords();
        }
    }
    validateCSVdata() {
        this.csvRecords.forEach(record => {
            if (this.currentJob['metaIndex']) {
                this.currentJob['metaIndex']['longitudeIndex'] = parseFloat(this.currentJob['metaIndex']['longitudeIndex']);
                this.currentJob['metaIndex']['latitudeIndex'] = parseFloat(this.currentJob['metaIndex']['latitudeIndex']);
                this.currentJob['metaIndex']['heightIndex'] = parseFloat(this.currentJob['metaIndex']['heightIndex']);
                let lo = this.currentJob['metaIndex']['longitudeAccuracyIndex'];
                let la = this.currentJob['metaIndex']['latitudeAccuracyIndex'];
                let he = this.currentJob['metaIndex']['heightAccuracyIndex'];
                if (isNaN(record[lo])) {
                    record[lo] = 0.02;
                }
                if (isNaN(record[la])) {
                    record[la] = 0.02;
                }
                if (isNaN(record[he])) {
                    record[he] = 0.02;
                }
            }
            if (this.currentJob['referenceIndex']) {
                this.currentJob['referenceIndex']['longitudeIndex'] = parseFloat(this.currentJob['referenceIndex']['longitudeIndex']);
                this.currentJob['referenceIndex']['latitudeIndex'] = parseFloat(this.currentJob['referenceIndex']['latitudeIndex']);
                this.currentJob['referenceIndex']['heightIndex'] = parseFloat(this.currentJob['referenceIndex']['heightIndex']);
                let lo = this.currentJob['referenceIndex']['longitudeAccuracyIndex'];
                let la = this.currentJob['referenceIndex']['latitudeAccuracyIndex'];
                let he = this.currentJob['referenceIndex']['heightAccuracyIndex'];
                if (isNaN(record[lo])) {
                    record[lo] = 0.02;
                }
                if (isNaN(record[la])) {
                    record[la] = 0.02;
                }
                if (isNaN(record[he])) {
                    record[he] = 0.02;
                }
            }
        });
    }
    makeCSVRecordscopy() {
        if (this.debug) {
            console.log('photogrammetry-meta :: makeCSVRecordsCopy()');
        }
        this.csvRecordsCopy = JSON.parse(JSON.stringify(this.csvRecords));
    }
    resetCSVRecords() {
        if (this.debug) {
            console.log('photogrammetry-meta :: resetCSVRecords()');
        }
        this.csvRecords = JSON.parse(JSON.stringify(this.csvRecordsFromImageHeader));
    }
    dup(n) {
        // return { ...n };
        return JSON.parse(JSON.stringify(n));
    }
    checkImportedCoords() {
        // CsvCoordsDifferentCRS:boolean = false;
        // CsvCoordsXYFlipped:boolean = false;
        console.log('%c photogram-meta :: checkImportedCoords() 1', Constants_1.Constants._purple, this.currentJob['originalRowXYZ'], this.currentJob['importedRowXYZ']);
        // if we have an imported coordinate system
        if (this.currentJob['importedRowXYZ']) {
            if (this.currentJob['importedRowXYZ'][1] < -180 || this.currentJob['importedRowXYZ'][1] > 180) {
                this.currentJob['CsvCoordsDifferentCRS'] = true;
            }
            if (this.currentJob['CsvCoordsDifferentCRS'] && this.selectedOption && this.selectedOption.desc) {
                // this.latitude.value = 'Latitude';
                // this.longitude.value = 'Longitude';
                var wgs84 = 'EPSG:4326'; // 'GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]]';
                var altcoordsystem = this.selectedOption.desc;
                // var alt = 'PROJCS["GDA_1994_MGA_Zone_56",GEOGCS["GCS_GDA_1994",DATUM["D_GDA_1994",SPHEROID["GRS_1980",6378137.0,298.257222101]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",153.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0]]';
                let long = this.selectedHeader.findIndex(value => value === this.longitude);
                let lat = this.selectedHeader.findIndex(value => value === this.latitude);
                console.log('!!!! original lat, long', lat, long);
                console.log('!!!! from,', altcoordsystem);
                console.log('!!!! to', wgs84);
                console.log('!!!! selectedOption', this.selectedOption);
                // console.log ( '!!!! source', from );
                let res = '';
                // let res2 = '';
                // let arr = this.originalImages.values;
                for (let mex of this.originalImages.values()) {
                    const me = this.dup(mex);
                    const coord = [this.dup(parseFloat(this.dup(me[long]))), this.dup(parseFloat(this.dup(me[lat])))];
                    let conv = this.epsgHelper.convert('EPSG:4326', altcoordsystem, coord);
                    // console.log ( 'conv coord,conv', mex, coord, conv, 
                    //    this.epsgHelper.convert ( 'EPSG:4326', altcoordsystem, [ this.dup(parseFloat(this.dup(me[long]))), this.dup(parseFloat(this.dup(me[lat]))) ] ),
                    //    this.epsgHelper.convert ( 'EPSG:4326', altcoordsystem, coord ));
                    res = res + me[0] + '\t' + conv[0] + '\t' + conv[1] + '\t' + parseFloat(me[3]) + '\t5\t5\t5\n';
                }
                ;
                console.log('###', res);
                // console.log ( '###', res2 );
                // do we have an original coordinate?
                if (this.currentJob['originalRowXYZ']) {
                    const la = this.dup(this.currentJob['originalRowXYZ'][lat]);
                    const lo = this.dup(this.currentJob['originalRowXYZ'][long]);
                    const ila = this.dup(this.currentJob['importedRowXYZ'][lat]);
                    const ilo = this.dup(this.currentJob['importedRowXYZ'][long]);
                    console.log('%c photogram-meta :: checkImportedCoords() 4', Constants_1.Constants._purple, la, lo, ila, ilo);
                    // wgs84
                    const original = [parseFloat(this.dup(lo)), parseFloat(this.dup(la))];
                    // const original_converted = this.epsgHelper.convert( wgs84, altcoordsystem, this.dup ( original ) );
                    // const original_back      = this.epsgHelper.convert( altcoordsystem, wgs84, this.dup ( original_converted ) );
                    // console.log ( "@@@ original, original_converted", original, original_converted, original_back );
                    console.log('%c photogram-meta :: checkImportedCoords() 5', Constants_1.Constants._purple, la, lo, ila, ilo, original);
                    // any
                    const imported = [parseFloat(this.dup(ilo)), parseFloat(this.dup(ila))];
                    const imported_flipped = [parseFloat(this.dup(ila)), parseFloat(this.dup(ilo))];
                    // console.log ( "@@@ imported, imported_flipped", imported, imported_flipped );
                    console.log('%c photogram-meta :: checkImportedCoords() 6', Constants_1.Constants._purple, la, lo, ila, ilo, original, imported);
                    // convert the incoming non-wgs84 into wgs84
                    const converted = this.epsgHelper.convert(altcoordsystem, wgs84, this.dup(imported));
                    const converted_flipped = this.epsgHelper.convert(altcoordsystem, wgs84, this.dup(imported_flipped));
                    // const converted_original = this.epsgHelper.convert( altcoordsystem, wgs84, this.epsgHelper.convert( wgs84, altcoordsystem, this.dup(original) ) );
                    // console.log ( "@@@ converted, converted_flipped, converted_original", converted, converted_flipped, converted_original );
                    console.log('%c photogram-meta :: checkImportedCoords() 7', Constants_1.Constants._purple, la, lo, ila, ilo, original, imported, converted);
                    let diff = this.calcDifference(original, converted);
                    let diff_flipped = this.calcDifference(original, converted_flipped);
                    console.log("@@@ diff", original, converted, diff, diff_flipped);
                    if (diff < 1) {
                        // console.log ( "!!!!!! diff OK");
                        this.currentJob['CsvCoordsXYFlipped'] = false;
                    }
                    if (diff_flipped < 1) {
                        console.log("!!!!!! diff_flipped OK");
                        this.currentJob['CsvCoordsXYFlipped'] = true;
                    }
                    this.data.currentJob['latLongSwap'] = this.currentJob['CsvCoordsXYFlipped'];
                }
                else {
                }
            }
        }
        else {
            // console.error ( 'photogram-meta :: checkImportedCoords() ERROR : missing original and imported coords');
        }
    }
    // a: 100,110  
    // b: 40,60
    // wrong: 100 - 40 + 110 - 60 = 110
    // right: 100 - 99 + 110 - 109 = 2
    calcDifference(a, b) {
        const res = (a[0] - b[0]) + (a[1] - b[1]);
        const c = Math.abs(Math.fround(res));
        // console.log ( 'calcDiff='+c, a, b, c);
        return c;
    }
    toDeg(n) {
        return n * 180 / Math.PI;
    }
    /*
    private updateCSVRecordByEPSGCode() {
      var geographicProjection = 'GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]]';
      var sourceProjection = this.selectedOption.desc;
      if(!sourceProjection){
        this.openSnackBarError('EPSG Codes do not have description');
        return;
      }
      //x = long , y= lat
      // 'Latitude', 'Longitude'
      let longitudeIndex = this.selectedHeader.findIndex(value => value === this.longitude);
      let latitudeIndex = this.selectedHeader.findIndex(value => value === this.latitude);
  
  
      let longLatArray = [];
      this.csvRecords.forEach(value => {
        // console.log(Projx4(sourceProjection,geographicProjection,[267665.867,6079938.686]));
        let xy = Projx4(sourceProjection, geographicProjection, [+value[longitudeIndex], +value[latitudeIndex]]);
        value[longitudeIndex] = xy[0];
        value[latitudeIndex] = xy[1];
      })
      this.makeCSVRecordscopy();
    }
  */
    latLongSwapping() {
        this.setLatLongHeightByCSRType(this.selectedOption);
        /*
        let state = this.currentJob['latLongSwap'];
    
        let lo = this.columnHeaders[1];
        let la = this.columnHeaders[2];
    
        this.columnHeaders[1] = 'Longitude';
        this.columnHeaders[2] = 'Latitude';
    */
        // let longitudeIndex = this.selectedHeader.findIndex(value => value === this.longitude);
        // let latitudeIndex = this.selectedHeader.findIndex(value => value === this.latitude);
        // if ( state ) {
        // yes, swap them
        // this.headersRowColumns[latitudeIndex] = this.longitude;
        // this.headersRowColumns[longitudeIndex] = this.latitude;
        // } else {
        // no swapping
        // this.headersRowColumns[latitudeIndex] = this.latitude;
        // this.headersRowColumns[longitudeIndex] = this.longitude;
        // }
        // console.log ( '%c swapping (state, lat, long, latLabel, longLabel)', Constants._pink, state, latitudeIndex, longitudeIndex, this.headersRowColumns[latitudeIndex], this.headersRowColumns[longitudeIndex] );
        /*
            this.csvRecords.forEach(value => {
              const tmp = value[longitudeIndex];
              value[longitudeIndex] = value[latitudeIndex];
              value[latitudeIndex] = tmp;
            })
            this.makeCSVRecordscopy();
        */
    }
}
exports.MetadataDialogComponent = MetadataDialogComponent;
